import Vue from 'vue'
//  login regist ....
import Router from 'vue-router'
import login from '@/views/users/login'
import register from '@/views/users/register'
import forgetPwd from '@/views/users/forgetPwd'
import updatePwd from '@/views/users/updatePwd'
// home
import home from '@/views/home/home'
//404
import Error from '@/views/common/404'
import head from '@/views/common/Head'
//咨询
import brand from '@/views/brand/brand'
//商品信息
import goods_detial from '@/views/goods/goods_detial'
//购物车
import cart from '@/views/cart/cart'
import shop from '@/views/cart/shop'
import pay from '@/views/cart/pay'
//personal
import collect from '@/views/personal/collect'
import change_pwd from '@/views/personal/change_pwd'
import order from '@/views/personal/order'
import order_all from '@/views/personal/order_all'
import order_unpaid from '@/views/personal/order_unpaid'
import order_detial from '@/views/personal/order_detial'
import order_paid from '@/views/personal/order_paid'
import order_finish from '@/views/personal/order_finish'
import address from '@/views/personal/address'
import personal_info from '@/views/personal/personal_info'
import personal from '@/views/personal/personal'

Vue.use(Router)

import {Message} from 'element-ui'
const meta = {requiresAuth: true}

let router = new Router({
  routes: [
    {
      path: '/',
      name: 'head',
      component: head,
      redirect: '/home',//路由重定位
      children:[
        {
          path: '/home',
          name: 'home',
          component: home,
          meta:{title:"首页",footerShow: true,}
        },//首页
        {
          path: '/brand',
          name: 'brand',
          component: brand,
          meta:{title:"品牌",footerShow: true,}
        },//品牌
        {
          path: '/cart',
          name: 'cart',
          component: cart,
          meta: {...meta},
          redirect: '/cart',//路由重定位
          children: [
            {
              path: '/cart',
              name: 'shop',
              meta: {...meta},
              component: shop,
            },
            {
              path: '/pay',
              name: 'pay',
              component: pay, meta: {...meta}
            },
          ]
        },//购物车
        {
          path: '/personal',
          name: 'personal',
          component: personal,
          meta: {...meta},
          redirect: '/personal/index',//路由重定位
          children: [
            {
              path: '/personal/index',
              name: 'personal_info',
              component: personal_info,
              meta: {...meta}
            },
            {
              path: '/personal/address',
              name: 'address',
              component: address,
              meta: {...meta}
            },
            {
              path: '/personal/order',
              name: 'order',
              component: order,
              redirect: '/personal/order/all',//路由重定位meta: {...meta},
              children: [{
                path: '/personal/order/all',
                name: '/personal/order/all',
                component: order_all,
                meta: {...meta}
              },
                {
                  path: '/personal/order/unpaid',
                  name: '/personal/order/unpaid',
                  component: order_unpaid,
                  meta: {...meta}
                },
                {
                  path: '/personal/order/paid',
                  name: '/personal/order/paid',
                  component: order_paid, meta: {...meta}
                },
                {
                  path: '/personal/order/finish',
                  name: '/personal/order/finish',
                  component: order_finish,
                  meta: {...meta}
                },
              ]
            },
            {
              path: '/personal/detial',
              name: '/personal/detial',
              component: order_detial,
              meta: {...meta}
            },
            {
              path: '/personal/changePwd',
              name: 'change_pwd',
              component: change_pwd,
              meta: {...meta}
            },
            {
              path: '/personal/collect',
              name: 'collect',
              component: collect,
              meta: {...meta}
            },
          ]
        },  //个人中心
        {path: '/login', name: 'login', component: login,},//用户信息
        {path: '/register', name: 'register', component: register,},
        {path: '/forgetPwd', name: 'forgetPwd', component: forgetPwd,},
        {path: '/updatePwd', name: 'updatePwd', component: updatePwd,},
        {
          path: '/goods_detial',
          name: 'goods_detial',
          component: goods_detial,
          meta:{title:"详情",footerShow: true,}
        },//商品详情
      ]
    },
    {
      path: '*',
      name: 'Error',
      component: Error,
      meta:{title:"404",footerShow: false,}
    },// 404
  ]
});
if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
  router = new Router({
    routes: [
      {
        path: '/',
        name: 'home',
        component: home,
        redirect: '/home',//路由重定位
        meta:{title:"首页",navShow: true,}
      },
      {
        path: '/home',
        name: 'home',
        component: home,
        meta:{title:"首页",navShow: true,}
      },//首页
      {
        path: '/brand',
        name: 'brand',
        component: brand,
        meta:{title:"品牌",navShow: true,}
      },//品牌
      {
        path: '/cart',
        name: 'cart',
        component: cart,
        meta: {...meta,title:"购物车",navShow: true,},
        redirect: '/cart',//路由重定位
        children: [
          {
            path: '/cart',
            name: 'shop',
            meta: {...meta,title:"购物车二级页面",navShow: true,},
            component: shop,
          },
          {
            path: '/pay',
            name: 'pay',
            component: pay,
            meta: {...meta,title:"支付页面",navShow: true,},
          },
        ]
      },//购物车
      {
        path: '/personal',
        name: 'personal',
        component: personal,
        meta: {...meta,title:"个人中心",navShow: true,},
      },  //个人中心
      {
        path: '/personal/index',
        name: 'personal_info',
        component: personal_info,
        meta: {...meta,title:"用户个人信息",navShow: false,},
      },
      {
        path: '/personal/address',
        name: 'address',
        component: address,
        meta: {...meta,title:"收货地址",navShow: false,},
      },
      {
        path: '/personal/order',
        name: 'order',
        component: order,
        redirect: '/personal/order/all',//路由重定位meta: {...meta},
        meta: {...meta,title:"订单",navShow: false,},
        children: [{
          path: '/personal/order/all',
          name: '/personal/order/all',
          component: order_all,
          meta: {...meta,title:"全部订单",navShow: false,},
        },
          {
            path: '/personal/order/unpaid',
            name: '/personal/order/unpaid',
            component: order_unpaid,
            meta: {...meta,title:"未付款",navShow: false,},
          },
          {
            path: '/personal/order/paid',
            name: '/personal/order/paid',
            component: order_paid,
            meta: {...meta,title:"已付款",navShow: false,},
          },
          {
            path: '/personal/order/finish',
            name: '/personal/order/finish',
            component: order_finish,
            meta: {...meta,title:"已完成",navShow: false,},
          },
        ]
      },
      {
        path: '/personal/detial',
        name: '/personal/detial',
        component: order_detial,
        meta: {...meta,title:"商品详情",navShow: false,},
      },
      {
        path: '/personal/changePwd',
        name: 'change_pwd',
        component: change_pwd,
        meta: {...meta,title:"修改密码",navShow: false,},
      },
      {
        path: '/personal/collect',
        name: 'collect',
        component: collect,
        meta: {...meta,title:"收藏",navShow: false,},
      },
      {path: '/login', name: 'login', component: login,},//用户信息
      {path: '/register', name: 'register', component: register,},
      {path: '/forgetPwd', name: 'forgetPwd', component: forgetPwd,},
      {path: '/updatePwd', name: 'updatePwd', component: updatePwd,},
      {path: '/goods_detial', name: 'goods_detial', component: goods_detial,},//商品详情

      // 404
      {
        path: '*',
        name: 'Error',
        component: Error,
      },
    ]
  })
}


//全局路由守卫
// router.beforeEach((to, from, next) => {
//   // document.title = to.meta.title;
//   //验证当前路由所有的匹配中是否需要有登录验证的
//   if (to.matched.some(r => r.meta.requiresAuth)) {
//     // 这里暂时将cookie里是否存有token作为验证是否登陆的条件
//     // 请根据自身业务需要修改
//     const token = localStorage.getItem("token") || 0;
//     if (token && token !== 'undefined') {
//       next();
//     } else {
//       //没有login的时候调到登陆界面
//       Message({
//         // showClose: true,
//         message: "まだログインしていませんよ~",
//         type: 'error',
//         duration: 1000
//       });
//       next({
//         name: 'login'
//       })
//     }
//   } else {
//     //不需要身份验证，直接通过
//     next()
//   }
// })

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js